import React, { useState, useEffect, useRef } from 'react';
import styles from './style.less';
import classnames from 'classnames';
import { useRequest, request, useLocation } from 'umi';
import { useUpdateEffect } from 'ahooks';
import {
  CaretUpOutlined,
  CaretRightOutlined,
  CaretDownOutlined,
  CaretLeftOutlined,
} from '@ant-design/icons';
import { message } from 'antd';
import { Row, Col, Divider, Image } from 'antd';
import dayjs from 'dayjs';

import { Cell, DateSelect, Button, Select, DatePicker, Picker } from 'zarm';

let apiPrefix = 'https://open.mokan.cn';

export default () => {
  const location = useLocation();
  const {
    type,
    projectId,
    contractNo,
    timestamp,
    clientCode,
    deviceId,
    serialNumber,
    sign,
  } = location.query;

  if (type === 'test') {
    apiPrefix = 'https://test-open.mokan.cn';
  }

  const [value, setValue] = useState('');
  const [showDatePicker, setShowDatePicker] = useState(false);
  const [selectDate, setSelectDate] = useState(dayjs().format('YYYY-MM-DD'));
  const [showTypePicker, setTypePicker] = useState(false);
  const [selectType, setSelectType] = useState({
    value: '',
    label: '全部快照',
  });

  const tempObj = {
    startTime: selectDate,
    endTime: selectDate,
  };
  if (selectType.value && selectType.value.length > 0) {
    tempObj.snapshotType = [selectType.value];
  } else {
    tempObj.snapshotType = [];
  }
  if (contractNo) {
    tempObj.contractNo = contractNo;
  } else if (projectId) {
    tempObj.projectId = projectId;
  }
  if (deviceId) {
    tempObj.deviceId = deviceId;
  }
  if (serialNumber) {
    tempObj.serialNumber = serialNumber;
  }

  const _getData = () => {
    if (!tempObj.projectId && !tempObj.contractNo) {
      return message.error('参数缺失');
    }
    return request(`${apiPrefix}/openapi/projectSnapshot/getSnapshotList`, {
      method: 'post',
      headers: {
        timestamp,
        clientCode,
        sign,
      },
      // params: {
      //   ...tempObj,
      // },
      data: {
        ...tempObj,
      },
    });
  };

  const { data, loading } = useRequest(
    () => {
      return _getData();
    },
    {
      onSuccess(response) {
        console.log(response);
      },
      refreshDeps: [selectType, selectDate],
    },
  );

  const dataSource = [
    {
      value: '',
      label: '全部快照',
    },
    {
      value: 'HUMAN',
      label: '人形快照',
    },
    {
      value: 'GENERAL',
      label: '工地快照',
    },
  ];

  if (!data) {
    return null;
  }

  return (
    <div className={styles.container}>
      <div className="paddingBox">
        <div className="topBox">
          <div className="item" onClick={() => setTypePicker(true)}>
            <div className="title">{selectType?.label || '快照类型'}</div>
            <img
              src={require('./assets/down.png')}
              alt=""
              className="markImg"
            />
          </div>
          <div className="item">
            <div className="title" onClick={() => setShowDatePicker(true)}>
              {selectDate || '请选择日期'}
            </div>
            <img
              src={require('./assets/down.png')}
              alt=""
              className="markImg"
            />
          </div>
        </div>
      </div>
      <DatePicker
        visible={showDatePicker}
        title="选择日期"
        okText="确定"
        cancelText="取消"
        mode="date"
        min="2007-01-03"
        max="2039-11-23"
        // value={state.limitDate.value}
        onOk={(value) => {
          let timeStr = dayjs(value).format('YYYY-MM-DD');
          setSelectDate(timeStr);
          setShowDatePicker(false);
        }}
        onCancel={() => setShowDatePicker(false)}
      />

      <Picker
        visible={showTypePicker}
        dataSource={dataSource}
        onOk={(selected) => {
          console.log('Cascade Picker onOk: ', selected[0]);
          setSelectType(selected[0]);
          setTypePicker(false);
        }}
        onCancel={() => setTypePicker(false)}
      />
      {data?.data[0]?.snapshots?.length > 0 ? (
        <Row gutter={[9, 9]}>
          {data?.data[0]?.snapshots?.map((v) => {
            return (
              <Col className="gutter-row" span={12}>
                <div className="itemBox">
                  <Image
                    src={v?.url}
                    alt=""
                    className="img"
                    // preview={{
                    //   src: v?.url,
                    // }}
                  />
                  <div className="title">{v?.time}</div>
                </div>
              </Col>
            );
          })}
        </Row>
      ) : (
        <div className="temp">
          <div className="title">暂无资源</div>
        </div>
      )}
    </div>
  );
};
